export const REQUIRED_VALIDATION = (label) => {
  return `${label} is Required!`;
};
